import { render, staticRenderFns } from "./NoMasEnviosPostales.vue?vue&type=template&id=77f4dd34&scoped=true&"
import script from "./NoMasEnviosPostales.vue?vue&type=script&lang=js&"
export * from "./NoMasEnviosPostales.vue?vue&type=script&lang=js&"
import style0 from "./NoMasEnviosPostales.vue?vue&type=style&index=0&id=77f4dd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f4dd34",
  null
  
)

export default component.exports